<ng-select
  class="ng-select--full-width-panel"
  #selectBox
  [class.portal-target--editable-search-term]="editableSearchTerm"
  [clearable]="clearable"
  [clearOnBackspace]="false"
  [clearSearchOnAdd]="false"
  [disabled]="disabled"
  [editableSearchTerm]="editableSearchTerm"
  [hidden]="readonly === 'text'"
  [items]="items$ | async"
  [ngModel]="value"
  [placeholder]="placeholder | translate"
  [readonly]="!!readonly"
  [selectOnTab]="true"
  [trackByFn]="trackByFn"
  [typeahead]="typeahead$"
  [typeToSearchText]="typeToSearch"
  [virtualScroll]="virtualScroll"
  (change)="onValueChanged($event)"
  (close)="onClose()"
  (search)="onSearch($event)"
  bindLabel="label"
  bindValue="value"
  clearAllText="{{ 'features.target.clear.tooltip' | translate }}"
  groupBy="group"
>
  <ng-template let-item="item" ng-label-tmp>
    {{ item.label }}
  </ng-template>

  <ng-template let-index="index" let-item="item" let-term="searchTerm" ng-option-tmp>
    <!-- Do not highlight the first item because it is the search term -->
    @if (index === 0) {
      <span>{{ item.meta?.description || item.label }}</span>
    } @else {
      @if (item.meta != null) {
        <div class="me-1" [innerHTML]="item.meta.optionName ?? item.meta.name | highlightText: term"></div>
      }
      @if (
        item.meta?.description != null ||
        item.meta?.infoBadge != null ||
        item.meta?.optionType != null ||
        item.meta?.type != null
      ) {
        <small>
          @if (item.meta.description != null) {
            <span class="me-1" [innerHTML]="item.meta.description | highlightText: term"></span>
          }
          @if (item.meta.optionType != null || item.meta.type != null) {
            <span class="me-1 text-muted">
              {{ item.meta.optionType || item.meta.type }}
            </span>
          }
          @if (item.meta.infoBadge != null) {
            <span class="badge text-bg-info me-1">
              {{ item.meta.infoBadge }}
            </span>
          }
        </small>
      }
      @if (item.meta == null) {
        <span [innerHTML]="item.label | highlightText: term"></span>
      }
    }
  </ng-template>
</ng-select>

<ng-template
  [portalTransclusion]="transclusions"
  [portalTransclusionContext]="{ entry: selectedEntry, isCustom: selectedEntry == null, value }"
  portalTransclusionName="description"
></ng-template>

@if (selectedEntry?.meta != null) {
  <div class="ps-1">
    @if (selectedEntry.meta.name != null && hideDescription === false) {
      <span class="me-1">
        {{ selectedEntry.meta.name }}
      </span>
    }
    @if (selectedEntry.meta.infoBadge != null) {
      <span class="badge text-bg-info me-1">
        {{ selectedEntry.meta.infoBadge }}
      </span>
    }
    @if (selectedEntry.meta.type != null) {
      <small class="text-muted">{{ selectedEntry.meta.type }}</small>
    }
  </div>
}

@if (readonly === 'text') {
  <div [innerHTML]="selectedItemsAsText(selectBox.selectedItems)"></div>
}
